import {
  accessTokenLocalStorageKey,
  connectorLocalStorageKey,
  initialConnectorIdLocalStorageKey,
  initialWalletLoginLocalStorageKey,
  walletConnectLocalStorageKey,
  walletLocalStorageKey
} from '@mprolab/sdk'
import { disconnect } from '@wagmi/core'
import { wagmiConfig } from 'lib/wagmiConfig'

export const clearUserStates = (isDeactive = false) => {
  if (window?.localStorage?.getItem(walletConnectLocalStorageKey)) {
    void disconnect(wagmiConfig).catch(() => {})
  }
  // Only clear localStorage when user disconnect,switch address no need clear it.
  if (isDeactive) {
    window?.localStorage?.removeItem(initialConnectorIdLocalStorageKey)
    window?.localStorage?.removeItem(connectorLocalStorageKey)
    window?.localStorage?.removeItem(walletLocalStorageKey)
    window?.localStorage?.removeItem(accessTokenLocalStorageKey)
    window?.localStorage?.removeItem(initialWalletLoginLocalStorageKey)
  }
}
